import type { NucampUser } from "$lib/datamodel";
import { type Writable } from "svelte/store";
import { userStore } from "./auth";
import { auth, db } from "../firebase";

export const user = userStore(auth, db) as Writable<NucampUser>;
